import { CommonProp, IconButton, IconDelete, Logo } from '@acin/ui-core';
import React from 'react';
import * as SC from './MappingItem.styled';

export interface MappingItemProps extends CommonProp {
  id?: string;
  name?: string | null;
  onDelete?: (id: string) => void;
}

export const MappingItem: React.FC<MappingItemProps> = ({ id, name, onDelete }) => {
  const handleDelete = () => {
    if (id && onDelete) {
      onDelete(id);
    }
  };

  return (
    <SC.MappingItemBox>
      <SC.LogoWrapper>
        <Logo size="medium" />
      </SC.LogoWrapper>
      <SC.Name>{name}</SC.Name>
      <SC.DeleteButtonWrapper>
        <IconButton size="small" label="Delete" onClick={handleDelete} icon={() => <IconDelete />} />
      </SC.DeleteButtonWrapper>
    </SC.MappingItemBox>
  );
};
